import React, {useState, useEffect} from "react";
import { GetCategoriesData } from "../../../lib/data";
import AddPackagesUi from "../../../ui/packagesUi/AddPackages";
import { TopResultOfPackags, positionOfPackags, shapOfPackags } from "../../../lib/definitions";
import i18n from "../../../lib/i18n";


export default function AddPackages () {

    const [categoriesData, setCategoriesData] = useState([]);
    const [loading, setLoading] = useState(false);
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        setLoading(true);
        const params = [ {"status":"sub"} ];
        const categoryData = await GetCategoriesData(1, params);
        setCategoriesData([]);
        categoryData.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        setLoading(false);
    };

    const search = async (param) => {
        const params = [ {"name": param},{"status":"sub"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesData([]);
            categoriesDataFilter.data.map((e) => setCategoriesData((prev) => [...prev, e]));
        }
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.package")}</h1>
                <AddPackagesUi search={search} loadingGet={loading} shapOfPackags={shapOfPackags} categoriesData={categoriesData} TopResultOfPackags={TopResultOfPackags} positionOfPackags={positionOfPackags}  />
            </div>
        </div>
    );
};